import icon1 from '../../../Assets/icon_card_wiseprevent_1.png'
import icon2 from '../../../Assets/icon_card_wiseprevent_2.png'
import icon3 from '../../../Assets/icon_card_wiseprevent_3.png'
import icon4 from '../../../Assets/icon_card_wiseprevent_4.png'
import icon5 from '../../../Assets/icon_card_wiseprevent_5.png'
import icon6 from '../../../Assets/icon_card_wiseprevent_6.png'
import logo from '../../../Assets/atendivet_logo2.png'
import img1 from '../../../Assets/Atendevet_Imagem_1.png'
import img2 from '../../../Assets/Atendevet_Imagem_2.png'
import { HeroSection } from '../Components/HeroSection'
import { CardSection } from '../Components/CardSection'
import { ValueSection } from '../Components/ValueSection'
import { FaqSection } from '../Components/FaqSection'

const CARDS = [
  {
    icon: icon1,
    title: "Prontuário Eletrônico com IA",
    text: "Transcrição e organização automática dos atendimentos, liberando o tempo do veterinário para o cuidado clínico.",
  },
  {
    icon: icon2,
    title: "Agendamento e Roteirização",
    text: "Cálculo de rotas para atendimento domiciliar e lembretes automáticos via WhatsApp para tutores.",
  },
  {
    icon: icon3,
    title: "Gestão Financeira e Fluxo de Caixa",
    text: "Controle entradas e saídas, incluindo gastos com deslocamento e serviços clínicos externos.",
  },
  {
    icon: icon4,
    title: "App para Tutores",
    text: "Acesso via web para histórico completo do pet, vacinas, prescrições, laudos e alertas.",
  },
  {
    icon: icon5,
    title: "Assinatura Digital e Documentação Legal",
    text: "Emissão de receitas e documentos com validade jurídica, integrados à prática veterinária.",
  },
  {
    icon: icon6,
    title: "Relatórios de Performance Clínica",
    text: "Indicadores de atendimento, evolução dos pacientes e eficiência da prática veterinária.",
  },
];

const BLOCKS = [
  {
    title: "Resultados que vão além da operação",
    text:
      `Profissionais veterinários e clínicas alcançam novos níveis de produtividade, qualidade no atendimento e retenção de clientes, através da digitalização e automação da rotina clínica.`,
    bullets: [
      {
        title: "Automatização que libera mais tempo para o cuidado com o paciente.",
        text: ""
      },
      {
        title: "Registros confiáveis e auditáveis para maior segurança jurídica.",
        text: ""
      },
      {
        title: "Plataforma escalável para clínicos autônomos e grandes redes.",
        text: ""
      },
    ],
    img: img2,
  },
];

const FAQ = [
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'Aliquam sit amet odio faucibus, sodales metus placerat, pharetra tortor. Donec ornare urna et tellus rhoncus gravida. Mauris efficitur purus sed ipsum pretium aliquet.'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
]
export const Atendevet = () => {
  return (
    <div>
      <HeroSection
        logo={logo}
        title='Inovação digital que transforma a prática veterinária com eficiência e precisão'
        text='O AtendeVet é uma plataforma completa para clínicas veterinárias e veterinários autônomos, que combina prontuário eletrônico avançado, agendamento inteligente e IA para automação da rotina de atendimento. '
        colorBtn='--color-11414b'
        url='https://www.atendevet.com.br/'
        img={img1}
      />

      <CardSection
        cards={CARDS}
        title='Gestão integrada que eleva a prática veterinária ao novo padrão digital'
        text='Com o AtendeVet, profissionais da saúde animal ganham mobilidade, precisão e agilidade: registros automáticos, emissão de laudos e acompanhamento do histórico do paciente — tudo em um único ambiente. '
      />

      <ValueSection
        blocks={BLOCKS}
      />

      {/* <FaqSection
        title="Suas principais dúvidas, respondidas"
        text={[
          'Com a WisePrevent, você reduz custos, prolonga a vida útil dos ativos e tem total controle do que foi feito, por quem e quando.',
          'Tudo rastreável, auditável e pronto para apresentar à gestão ou aos órgãos reguladores.'
        ]}
        colorBtn='--color-ff7022'
        faq={FAQ}
      /> */}

    </div>
  )
}
